export default (route_1 = {}, route_2) => {
  const path_1 = route_1.path
  const path_2 = route_2.path
  const query_1 = route_1.query || {}
  const query_2 = route_2.query || {}

  // 拼接路径
  const val_query_1 = Object.keys(query_1).map(v => v + '=' + query_1[v]).join('&')
  const val_1 = val_query_1 ? `${path_1}?${val_query_1}` : path_1
  const val_query_2 = Object.keys(query_2).map(v => v + '=' + query_2[v]).join('&')
  const val_2 =  val_query_2 ? `${path_2}?${val_query_2}` : path_2
  
  return val_1 === val_2
}